module.exports = __webpack_public_path__ + "linea-music-10.83767d2d18790bbcd939.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/linea-icons/fonts/linea-music-10.svg
// module id = ../../../../../theme/scss/icons/linea-icons/fonts/linea-music-10.svg
// module chunks = styles